module.exports = __webpack_public_path__ + "media/images/401-play-logo-big-white-e8c521ac2cd3e737fa1dce2d7bfe6959.png";